// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","loginLink":"Footer_loginLink__00nfO","stars":"Footer_stars__evAmJ","seoLinks":"Footer_seoLinks__8cfU3"};